import { IInterest } from "api/types";
import * as React from "react";
import { FunctionComponent } from "react";
import ElementBlock from "../Common/ElementBlock/ElementBlock";

interface IProps {
  elements?: IInterest[];
  onChange?: (interest: IInterest) => void;
}

const Interests: FunctionComponent<IProps> = ({ elements = [], onChange }) => {
  const onChangeHandler = (interest: IInterest) => () => {
    if (onChange) {
      onChange(interest);
    }
  };
  return (
    <>
      {elements.map((interest: IInterest, key) => (
        <ElementBlock
          key={key}
          name={interest.name}
          imageUrl={interest.image}
          onClick={onChangeHandler(interest)}
          checked={interest.checked}
        />
      ))}
    </>
  );
};
export default Interests;



// WEBPACK FOOTER //
// ./src/components/ElementSelector/Interests/Interests.tsx